export enum FileStatus {
  AVAILABLE = 'AVAILABLE',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
  ENCODING = 'ENCODING',
}
